<template>
    <div style="margin-right: 25px;">
    <md-field>
        <label>{{ $t("seller.upload.Currency") }}</label>
        <TbSelect :value="moduleValue"
				  @md-selected="onSelect"
				  :search-allow="true"
				  :options="currencyList"
				  required
		/>
    </md-field>
    </div>
</template>

<script>
import {dashboardInspectionApi} from "@/common/api/dashboardInspectionApi";

export default {
	created() {
		this.getCurrencyList()
	},
    data() {
		return {
			moduleValue: "",
			currencyList: []
        }
    },
	methods: {
		onSelect(data) {
			this.$store.dispatch("setActionDashboardFilter", { currency: data });
		},
		getCurrencyList() {
			dashboardInspectionApi.seller
                .currencies()
                .then(res => {
					this.currencyList=res;
					this.moduleValue=res[0];
					this.onSelect();
                })
                .catch(err => {
                    console.log("err", err);
                });
		}
	}
}
</script>